import React from "react"; 
import logo from './assets/toleologo.png'
import boegimg from './assets/boeg_final.png'
import combineImg from './assets/combine.png'
 
import './App.scss';

function Thanks() { 

  let handleSubmit, email, handleChange, error, success = null

  return ( 
    <div id="main" className="App text-white bg-black">
        <div className="page-padding">
        <div className="container-large">
        <div className="flex items-center justify-between" id="header">
        <div className="" id="">
          <a href="/"><img src={logo} className="logo"></img></a>
        </div>
        <div className="" id="">
          
        </div>
      </div>

      <div className="" id="banner">
        <div className="" id="headerimage">
          <div className="mx-auto" id="">
            <img src={combineImg} className="mx-auto boeg-image" alt="main nft"></img>
            {/* <img src={checkmark} className="mx-auto w-1/2 checkmark-image" alt="checkmark"></img> */}
          </div>
        </div>
        <div className="" id="buysection">
          <div className="title-wrapper">
          <h1 className="maintitle subpage">Herzlichen Dank</h1>
          <h1 className="maintitle subpage">für die Abonnierung unseres Newsletters!</h1>
          </div>
           <a href="/"><button className="mt-8   float-right text-lg lg:text-2xl 2xl:text-3xl" id="openModalBtn" >Zur Startseite</button></a>
        </div>
      </div>


      <div className="" id="footer">
        <div className="footer-wrapper">
          <p></p>
          <a href="/kontakt"><p className="">Kontakt</p></a>
          <a href="/agb"><p>AGBs</p></a>
          <a href="/impressum"><p className="">Impressum</p></a>
          <p></p>
        </div>
      </div>

    </div> 
    </div> 
    </div> 
  ); 
} 
 
export default Thanks; 